import {createRoot} from 'react-dom/client'
// Axios
import axios from "./app/helpers/axios";
// Apps
import {MetronicI18nProvider} from './_metronic/i18n/Metronici18n'
/**
 * TIP: Replace this style import with dark styles to enable dark mode
 *
 * import './_metronic/assets/sass/style.dark.scss'
 *
 * TIP: Replace this style import with rtl styles to enable rtl mode
 *
 * import './_metronic/assets/css/style.rtl.css'
 **/
import './_metronic/assets/sass/plugins.scss'
import './_metronic/assets/sass/style.scss'
import './_metronic/assets/sass/style.react.scss'

import 'react-block-ui/style.css';
import './app/sass/custom.scss'

import {AppRoutes} from './app/routing/AppRoutes'
import {AuthProvider, setupAxios} from './app/modules/auth'
import {ThemeModeProvider} from './_metronic/partials/layout/theme-mode/ThemeModeProvider'
import {WorkboxUpdateNotifier} from "./app/modules/Workbox/WorkboxUpdateNotifier";
/**
 * Creates `axios-mock-adapter` instance for provided `axios` instance, add
 * basic Metronic mocks and returns it.
 *
 * @see https://github.com/ctimmerm/axios-mock-adapter
 */
/**
 * Inject Metronic interceptors for axios.
 *
 * @see https://github.com/axios/axios#interceptors
 */
setupAxios(axios)

const container = document.getElementById('root')
if (container) {
    createRoot(container).render(
        <>
            <MetronicI18nProvider>
                <ThemeModeProvider>
                    <AuthProvider>
                        <AppRoutes/>
                    </AuthProvider>
                </ThemeModeProvider>
            </MetronicI18nProvider>
            <WorkboxUpdateNotifier/>
        </>
    )
}
